<template>
    <div>
        <el-dialog
            :title="dialogFormTitle"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="30%"
            :center="true"
            top="20vh"
            :close-on-click-modal="false"
            :before-close="() => closeRouteModelDialog('RouteModelEditForm')"
            v-loading.fullscreen.lock="login_loading"
        >
            <div>
                <el-form
                    :model="RouteModel"
                    :rules="rules"
                    ref="RouteModelEditForm"
                    label-width="100px"
                    size="small"
                >
                    <div v-if="show_type">
                        <el-form-item label="分类名称" prop="name">
                            <el-input
                                v-model="RouteModel.name"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="图标样式代码" prop="icon">
                            <el-input
                                v-model="RouteModel.icon"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div v-else>
                        <el-descriptions
                            class="margin-top"
                            :column="1"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>分类名称</span>
                                </template>
                                <span>{{RouteModel.name}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>图标样式代码</span>
                                </template>
                                <span>{{RouteModel.icon}}</span>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <el-button
                        v-if="$_has(edit_auth)"
                        type="primary"
                        plain
                        @click="$emit('show_edit')"
                        >修改</el-button
                    >
                    <el-button
                        v-if="$_has(del_auth)"
                        type="danger"
                        plain
                        @click="RouteModelDel('RouteModelEditForm')"
                        >删除</el-button
                    >
                    <el-button
                        plain
                        @click="closeRouteModelDialog('RouteModelEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('RouteModelEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm('RouteModelEditForm')"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closeRouteModelDialog('RouteModelEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('RouteModelEditForm')"
                        >确定修改</el-button
                    >
                    <el-button
                        plain
                        @click="closeRouteModelDialog('RouteModelEditForm')"
                        >取消操作</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { route_model_add_request,route_model_del_request,route_model_edit_request } from '@/network/RouteModel.js'

export default {
    name: 'RouteModelEditComponent',
    data() {
        return {
            login_loading: false,
            RouteModel: {
                name: '',
                icon: '',
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入分类名称',
                        trigger: 'blur',
                    },
                    {
                        min: 2,
                        max: 16,
                        message: '长度在 2 到 16 个字符',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return '分类详情'
            } else if (this.show_type === 1) {
                return '添加分类'
            } else {
                return '修改分类'
            }
        },
    },
    methods: {
        closeRouteModelDialog(formName) {
            this.resetForm(formName)
            this.$emit('exitRouteModelDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.RouteModelInsert(formName)
            })
        },
        RouteModelInsert(formName) {
            this.login_loading = true
            route_model_add_request(this.RouteModel)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitRouteModelDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm(formName) {
            this.RouteModel = {
                name: '',
                icon: '',
            }
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.RouteModelEdit(formName)
            })
        },
        RouteModelEdit(formName) {
            this.login_loading = true
            this.RouteModel.id = this.id
            route_model_edit_request(this.RouteModel)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitRouteModelDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.RouteModel.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        RouteModelDel(formName) {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    route_model_del_request(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closeRouteModelDialog(formName))
                })
                .catch((err) => {})
        },
    },
    filters: {},
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        route_model_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        edit_auth: String,
        del_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {
        route_model_details_data(newVal) {
            this.RouteModel = newVal
        },
    },
}
</script>

<style>
</style>